(function () {

    "use strict";

    function usersStore($http, $q, $log, $rootScope, routeGenerator, User) {

        var vm = this;

        vm.getUsers = getUsers;
        vm.getUsersState = getUsersState;
        vm.getUser = getUser;
        vm.getUserPublic = getUserPublic;
        vm.deleteUser = deleteUser;
        vm.createOrUpdateUser = createOrUpdateUser;
        vm.createOrUpdateUserConPhoto = createOrUpdateUserConPhoto;
        vm.updateMyUser = updateMyUser;
        vm.updateMyUserConPhoto = updateMyUserConPhoto;
        vm.getMyProfile = getMyProfile;
        vm.clearMyProfile = clearMyProfile;
        vm.getMyLanguage = getMyLanguage;
        vm.updateGroups = updateGroups;
        vm.getGroupsUnassigned = getGroupsUnassigned;
        vm.getGroups = getGroups;
        vm.photo = photo;
        vm.findUsers = findUsers;
        vm.getLoggedUserData = getLoggedUserData;

        function photo(id) {
            return $q(function (resolve, reject) {

                if (!id) {
                    reject();
                    return;
                }

                $http.get(routeFor("photo/" + id), { cache: true })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving photo from remote store.");
                        console.dir(error);
                        reject();
                    });
            });
        }

        function routeFor(route) {
            var urlRoot = "users/";
            return routeGenerator.generateApiRoute(urlRoot + route);
        }

        function getUsers(page, numporpage) {
            return $q(function (resolve, reject) {
                $http.get(routeFor("" + page + "/" + numporpage))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });

        }

        function getUsersState(state, page, numporpage) {
            console.log("state/" + state + "/" + page + "/" + numporpage);
            return $q(function (resolve, reject) {
                $http.get(routeFor("state/" + state + "/" + page + "/" + numporpage))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });
        }

        function getMyProfile() {

            var userProfilePromise = $q.defer();

            $http.get(routeFor("miperfil")).then(function (response) {
                userProfilePromise.resolve(response.data);
            }).catch(function (error) {
                $log.error("Error retrieving users from remote store.");
                console.dir(error);
                userProfilePromise.reject();
            });

            return userProfilePromise.promise;
        }

        function clearMyProfile() {
            $rootScope.user = {};
        }

        function getMyLanguage() {
            return $q(function (resolve, reject) {
                $http.get(routeFor("mylanguage"))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving language from user from remote store.");
                        console.dir(error);
                        reject();
                    });
            });

        }

        function getUser(id) {
            return $q(function (resolve, reject) {
                $http.get(routeFor("user?id=" + id))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });
        }

        function getUserPublic(id) {
            return $q(function (resolve, reject) {
                $http.get(routeFor("user/public?id=" + id))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });

        }

        function deleteUser(id) {
            return $q(function (resolve, reject) {
                $http.post(routeFor("delete?id=" + id))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function () {
                        reject("Error");
                    });
            });
        }

        function createOrUpdateUser(user) {
            return $q(function (resolve, reject) {
                var endpoint = "";
                if (user.id) {
                    endpoint = "updateUser";
                } else {
                    endpoint = "createUser";
                }
                $http({ method: "POST", data: user, cache: false, url: routeFor(endpoint) })
                    .then(function (response) {
                        resolve(response.data);
                    }).catch(function (error) {
                        reject(error);
                    });
            });
        }

        function updateMyUser(user) {
            return $q(function (resolve, reject) {
                var endpoint = "updateMyUser";
                clearMyProfile();

                $http({ method: "PUT", data: user, cache: false, url: routeFor(endpoint) })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function updateGroups(user) {
            return $q(function (resolve, reject) {
                var endpoint = "updateGroupsUser/" + user.id;
                var idGroupsUserActualizar = [];
                user.groups.forEach(
                    function addNumber(group) {
                        idGroupsUserActualizar.push(group.id);
                    }
                );

                $http({
                    method: "PUT",
                    data: idGroupsUserActualizar,
                    cache: false,
                    url: routeFor(endpoint)
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function getGroupsUnassigned(idUser) {
            return $q(function (resolve, reject) {
                $http.get(routeFor("getGroupsUnassigned/" + idUser))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });
        }

        function getGroups(idUser) {
            return $q(function (resolve, reject) {
                $http.get(routeFor("groups/" + idUser))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });

        }

        function createOrUpdateUserConPhoto(user, photo) {
            if (photo) {
                return $q(function (resolve, reject) {
                    $http({
                        method: "POST",
                        url: routeFor("updatePhoto"),
                        data: photo,
                        headers: {
                            'Content-Type': undefined
                        }
                    })
                        .then(function (response) {
                            resolve(response.data);
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                });
            }
            return createOrUpdateUser(user);
        }

        function updateMyUserConPhoto(user, photo) {
            if (photo) {
                return $q(function (resolve, reject) {
                    $http({
                        method: "POST",
                        url: routeFor("updatePhoto"),
                        data: photo,
                        headers: {
                            'Content-Type': undefined
                        }
                    })
                        .then(function (response) {
                            resolve(response.data);
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                });
            }
            return updateMyUser(user);
        }

        function findUsers(page, numporpage, state, typeSearch, cadena) {
            return $q(function (resolve, reject) {
                $http.get(routeFor(state + "/" + page + "/" + numporpage + "/" + typeSearch + "?cadena=" + encodeURIComponent(cadena)))
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        $log.error("Error retrieving users from remote store.");
                        console.dir(error);
                        reject();
                    });
            });
        }

        function getLoggedUserData() {
            return $q(function (resolve, reject) {
                if ($rootScope.user.name) {
                    resolve($rootScope.user);
                    return;
                };

                getMyProfile().then(function (user) {
                    vm.user = new User().deserialize(user);

                    photo(vm.user.id).then(function (photo) {
                        vm.user.user = photo;
                        $rootScope.user = vm.user;
                        resolve(vm.user);
                    }).catch(function (error) {
                        reject(error);
                    });

                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

    usersStore.$inject = ["$http", "$q", "$log", "$rootScope", "sphForms.routeGenerator", "sphForms.modelUser"];

    angular.module("sphForms.auth").service("sphForms.usersStore", usersStore);

})();